import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

export default {
  getProjectList(params) {
    return request.post({
      url: 'feidian.bdapp.project.list',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getProjectConfig(params) {
    return request.post({
      url: 'feidian.config.getConfig',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getProjectTaskList(params) {
    return request.post({
      url: 'feidian.bdapp.project.taskList',
      data: {
        ...getCommonParams(),
        ...params,
      },
      timeout: 20 * 1000,
    })
  },
  getShopGroupDetail(params) {
    return request.post({
      url: 'feidian.bdapp.project.shopGroupDetail',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getProjectTaskConfig(params) {
    return request.get({
      url: 'feidian.project.task.config',
      params: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getProjectTaskIncomplete(params) {
    return request.post({
      url: 'feidian.project.task.incomplete',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  // 获取未完成反馈表单配置（根据taskTemplateId）
  getFieldConfig(params) {
    return request.get({
      url: 'crm.index.common.getFieldConfig',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
}
